import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Input } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const PaginationGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const [offset, setOffset] = useState(typeof caseFilter.offset === 'number' ? `${caseFilter.offset}` : '');
    const [limit, setLimit] = useState(typeof caseFilter.limit === 'number' ? `${caseFilter.limit}` : '');
    const checkInput = (value) => {
        let v = value;
        if (typeof v === 'string') {
            v = parseInt(v);
        }
        if (isNaN(v) || v < 0 || v.toString().includes('e')) {
            return '';
        }
        return v;
    };
    if (props.hidePaginationGroup) {
        return null;
    }
    return (React.createElement(FilterGroup, { name: lang.caseFilter.pagination },
        React.createElement(FilterOption, { active: !!caseFilter.offset, header: lang.caseFilter.offset, subheader: lang.caseFilter.offsetExplanation, onDeactivate: () => caseFilterStore.clearFilter('offset') },
            React.createElement(Input, { type: "number", min: 0, placeholder: lang.caseFilter.offset, value: offset, onSubmit: !isNaN(parseInt(`${offset}`)) &&
                    parseInt(`${offset}`) !== caseFilter.offset
                    ? () => {
                        caseFilterStore.updateFilter({
                            offset: parseInt(`${offset}`),
                        });
                    }
                    : undefined, onChange: (e) => {
                    const v = e.target.value;
                    setOffset(checkInput(v));
                }, style: { marginBottom: '0' } })),
        React.createElement(FilterOption, { active: !!caseFilter.limit, header: lang.caseFilter.limit, subheader: lang.caseFilter.limitExplanation, onDeactivate: () => caseFilterStore.clearFilter('limit') },
            React.createElement(Input, { type: "number", min: 0, placeholder: lang.caseFilter.limit, value: limit, onSubmit: !isNaN(parseInt(`${limit}`)) &&
                    parseInt(`${limit}`) !== caseFilter.limit
                    ? () => {
                        caseFilterStore.updateFilter({
                            limit: parseInt(`${limit}`),
                        });
                    }
                    : undefined, onChange: (e) => {
                    const v = e.target.value;
                    setLimit(checkInput(v));
                }, style: { marginBottom: '0' } }))));
};
export default PaginationGroup;
//# sourceMappingURL=PaginationGroup.js.map